/*
    Copyright (C) 2023 - Wheel and Brake - Southwest Airlines
*/
import React from "react";
import $ from "jquery";
import ReactDOM from "react-dom/client";
import "./main/frontend/App.css"
import {Login} from "./main/utilities/auth/Login";
import registerInterceptors from "./interceptor";

const root = ReactDOM.createRoot(document.getElementById('root'));
window.$ = $;
registerInterceptors();
root.render(
    <Login/>
);
